import { useIntl } from '@/intl'
import {
  golfEditingValueForSlotSelector,
  golfLocationsSelector,
} from '@/scopes/checkout/components/services/GolfService/selectors'
import {
  getGolfSlotIdBeingEdited,
  useGolfServiceStore,
} from '@/scopes/checkout/components/services/GolfService/store'
import { updateEditingGolfSlotLocation } from '@/scopes/checkout/domain/actions'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { Dropdown } from '@sunwebgroup/uds-ui/dropdown'
import * as React from 'react'

export function LocationFilter() {
  const intl = useIntl()
  const { service, setServiceLocalValue } = useService(ServiceType.Golf)
  const slotId = useGolfServiceStore(getGolfSlotIdBeingEdited)

  const locations = golfLocationsSelector(service)

  const slot = golfEditingValueForSlotSelector(service, slotId)

  const handleChange = (locationId: string) => {
    setServiceLocalValue(updateEditingGolfSlotLocation({ slotId, locationId }))
  }

  return (
    <Dropdown.Root value={slot?.locationId ?? ''} onValueChange={handleChange}>
      <Dropdown.Trigger
        label={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_location_label' })}
      />
      <Dropdown.Content>
        {locations.map(loc => (
          <Dropdown.Item key={loc.id} value={loc.id}>{loc.name}</Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}
